/**
 * Vue Toastification Plugin
 * 
 * Красивые стекирующиеся уведомления как в ВКонтакте
 * - Группируются справа
 * - Копятся друг за другом
 * - Поддержка аватаров, иконок, actions
 */

import Vue from 'vue';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const options: any = {
  // Позиция: справа снизу (как в ВК)
  position: POSITION.BOTTOM_RIGHT,
  
  // Убираем автоматическое скрытие - уведомления постоянные
  timeout: false,
  
  // Закрытие по клику на крестик (не на само уведомление)
  closeOnClick: false,
  
  // Пауза при наведении
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  
  // Кнопка закрытия - всегда показывать
  closeButton: 'button',
  
  // Иконка
  icon: false,
  
  // Progress bar - скрываем, т.к. нет таймера
  hideProgressBar: true,
  
  // RTL поддержка
  rtl: false,
  
  // Максимум уведомлений на экране (копятся друг за другом)
  maxToasts: 10,
  
  // Новые сверху или снизу
  newestOnTop: true,
  
  // Transition (простая fade вместо bounce для избежания двойной анимации)
  transition: 'Vue-Toastification__fade',
  
  // Кастомные CSS классы
  toastClassName: 'custom-toast',
  bodyClassName: 'custom-toast-body',
  
  // Accessibility
  draggable: true,
  draggablePercent: 0.6,
  
  // Крестик всегда видимый (не только при hover)
  showCloseButtonOnHover: false,
  
  // Не фильтруем дубликаты - пусть показываются все уведомления
  // filterBeforeCreate отключен, чтобы избежать двойного рендеринга
};

Vue.use(Toast, options);

export default Toast;

